<div class="wrapper">
  <div class="picker">
    <div class="btn btn-rbv" (click)="pickFile()"><fa name="fa fa-paperclip"></fa> Pick File</div>
    <input #attachement class="input-file" name="attachmentFile" type="file" (change)="fileChangeEvent($event)" multiple
    accept="image/png, image/jpeg, .pdf, .xls, .xlsx, .doc, .docx"/>
  </div>

  <div *ngIf="ArrayOfSelectedFile?.length > 0" class="files">
    <div class="file" *ngFor="let f of ArrayOfSelectedFile; let i = index">
      <span>{{f.name}}</span>
      <fa name="fa fa-close" (click)="removedSelectedFile(i)"></fa>
    </div>
  </div>
</div>
